<!-- Main Content -->
<div class="h-full bg-gray-50 flex flex-col px-4 sm:px-6 lg:px-8 py-4">
  <div
    class="w-full max-w-4xl mx-auto flex flex-col gap-4 border border-gray-300 rounded-lg bg-white"
  >
    <!-- Form Header -->
    <lib-feature-header
      [title]="'Your Profile'"
      [hideCloseButton]="hideCloseButton()"
      (closeClick)="onCloseClick()"
    >
      <!-- Profile status or additional info can go here -->
    </lib-feature-header>

    <!-- Tab Navigation -->
    <div class="animate-slideInUp" style="animation-delay: 100ms">
      <sb-tabs-navigation
        [tabs]="tabItems"
        [activeTab]="activeTab()"
        (tabChanged)="onTabChanged($event)"
      />
    </div>

    <div class="p-4">
      <!-- Profile Information Tab -->
      @if (activeTab() === 'profile') {
      <sb-profile-form />
      }

      <!-- Change Password Tab -->
      @if (activeTab() === 'change-password') {
      <sb-change-password-form />
      }

      <!-- Sessions Tab -->
      @if (activeTab() === 'sessions') {
      <sb-sessions-list />
      }
    </div>
  </div>
</div>
